const translationKeys = {
  funds_overview_header_title: 'funds_overview_header_title',
  funds_overview_header_subtitle: 'funds_overview_header_subtitle',
  funds_overview_find_funds_button: 'funds_overview_find_funds_button',
  funds_cost_price: 'funds_cost_price',
  funds_holdings_return: 'funds_holdings_return',
  funds_holdings_return_in_percent: 'funds_holdings_return_in_percent',
  funds_pending_purchase: 'funds_pending_purchase',
  funds_my_watchlist: 'funds_my_watchlist',
  funds_savings_agreements_error_text: 'funds_savings_agreements_error_text',
  funds_transactions_section_title: 'funds_transactions_section_title',
  funds_transactions_error_text: 'funds_transactions_error_text',
  funds_savings_agreement_create_savings_agreement_button:
    'funds_savings_agreement_create_savings_agreement_button',
  funds_savings_agreements_section_title:
    'funds_savings_agreements_section_title',
  funds_savings_agreement_frequency_monthly:
    'funds_savings_agreement_frequency_monthly',
  funds_savings_agreement_frequency_two_months:
    'funds_savings_agreement_frequency_two_months',
  funds_savings_agreement_frequency_annual:
    'funds_savings_agreement_frequency_annual',
  funds_savings_agreement_frequency_quarterly:
    'funds_savings_agreement_frequency_quarterly',
  funds_savings_agreement_frequency_tertiarly:
    'funds_savings_agreement_frequency_tertiarly',
  funds_savings_agreement_frequency_six_months:
    'funds_savings_agreement_frequency_six_months',
  funds_savings_agreement_frequency_undefined:
    'funds_savings_agreement_frequency_undefined',
  funds_savings_agreement_next_payment: 'funds_savings_agreement_next_payment',
  funds_savings_agreement_no_savings_agreements:
    'funds_savings_agreement_no_savings_agreements',
  funds_holding_performance_last_updated_label:
    'funds_holding_performance_last_updated_label',
  funds_fund_accounts_error_text: 'funds_fund_accounts_error_text',
  funds_fund_accounts_no_fund_accounts: 'funds_fund_accounts_no_fund_accounts',
  funds_fund_account_type_ask: 'funds_fund_account_type_ask',
  funds_fund_account_type_ips: 'funds_fund_account_type_ips',
  funds_fund_account_type_general: 'funds_fund_account_type_general',
  funds_mutual_funds_no_fund_holdings: 'funds_mutual_funds_no_fund_holdings',
  funds_mutual_funds_error_text: 'funds_mutual_funds_error_text',
  funds_overview_breadcrumb_homepage: 'funds_overview_breadcrumb_homepage',
  funds_overview_breadcrumb_savings: 'funds_overview_breadcrumb_savings',
  funds_transactions_no_fund_transactions:
    'funds_transactions_no_fund_transactions',
  funds_mutual_fund_details_loading_text:
    'funds_mutual_fund_details_loading_text',
  funds_mutual_fund_details_error_text: 'funds_mutual_fund_details_error_text',
  fund_details_tab_holding_title: 'fund_details_tab_holding_title',
  fund_details_tab_about_title: 'fund_details_tab_about_title',
  fund_details_tab_transactions_title: 'fund_details_tab_transactions_title',
  funds_fund_transaction_type_redemption:
    'funds_fund_transaction_type_redemption',
  funds_fund_transaction_type_purchase: 'funds_fund_transaction_type_purchase',
  funds_fund_transaction_type_switch_purchase:
    'funds_fund_transaction_type_switch_purchase',
  funds_fund_transaction_type_switch_redemption:
    'funds_fund_transaction_type_switch_redemption',
  funds_fund_transaction_type_event_purchase:
    'funds_fund_transaction_type_event_purchase',
  funds_fund_transaction_type_event_redemption:
    'funds_fund_transaction_type_event_redemption',
  funds_fund_transaction_type_switch_fund_accounts_purchase:
    'funds_fund_transaction_type_switch_fund_accounts_purchase',
  funds_fund_transaction_type_switch_fund_accounts_redemption:
    'funds_fund_transaction_type_switch_fund_accounts_redemption',
  funds_fund_transaction_type_savingsagreement:
    'funds_fund_transaction_type_savingsagreement',
  funds_fund_transaction_type_ask_move_out:
    'funds_fund_transaction_type_ask_move_out',
  funds_fund_transaction_type_ask_move_in:
    'funds_fund_transaction_type_ask_move_in',
  funds_fund_transaction_type_ips_move_in:
    'funds_fund_transaction_type_ips_move_in',
  funds_fund_transaction_type_ips_move_out:
    'funds_fund_transaction_type_ips_move_out',
  funds_fund_transaction_type_payment_agreement:
    'funds_fund_transaction_type_payment_agreement',
  funds_fund_transaction_type_dividend_purchase:
    'funds_fund_transaction_type_dividend_purchase',
  funds_fund_transaction_type_dividend_redemption:
    'funds_fund_transaction_type_dividend_redemption',
  funds_details_annual_fee_explanation_text:
    'funds_details_annual_fee_explanation_text',
  funds_fund_order_section_title: 'funds_fund_order_section_title',
  funds_fund_orders_details: 'funds_fund_orders_details',
  funds_transactions_filter_title: 'funds_transactions_filter_title',
  funds_transactions_filter_input_label:
    'funds_transactions_filter_input_label',
  funds_transactions_filter_input_placeholder:
    'funds_transactions_filter_input_placeholder',
  funds_fund_account_create_ask_card_title:
    'funds_fund_account_create_ask_card_title',
  funds_fund_account_create_ask_card_content:
    'funds_fund_account_create_ask_card_content',
  funds_fund_account_create_ask_card_button_text:
    'funds_fund_account_create_ask_card_button_text',
  funds_savings_agreement_create_savings_agreement_card_button_text:
    'funds_savings_agreement_create_savings_agreement_card_button_text',
  funds_savings_agreement_create_savings_agreement_card_content:
    'funds_savings_agreement_create_savings_agreement_card_content',
  funds_savings_agreement_create_savings_agreement_card_title:
    'funds_savings_agreement_create_savings_agreement_card_title',
  funds_fund_orders_error_text: 'funds_fund_orders_error_text',
  funds_annual_cost_percentage: 'funds_annual_cost_percentage',
  funds_return_one_year: 'funds_return_one_year',
  funds_risk_score: 'funds_risk_score',
  funds_my_funds: 'funds_my_funds',
  funds_funds_market_card_title: 'funds_funds_market_card_title',
  funds_funds_market_card_content: 'funds_funds_market_card_content',
  funds_funds_market_card_button_text: 'funds_funds_market_card_button_text',
  funds_fund_transaction_type_tag_label:
    'funds_fund_transaction_type_tag_label',
  funds_fund_name: 'funds_fund_name',
  funds_funds_overview_chart_return_tab_title:
    'funds_funds_overview_chart_return_tab_title',
  funds_funds_overview_chart_holdings_tab_title:
    'funds_funds_overview_chart_holdings_tab_title',
  funds_fund_asset_class_type_aksjefond:
    'funds_fund_asset_class_type_aksjefond',
  funds_fund_asset_class_type_obligasjonsfond:
    'funds_fund_asset_class_type_obligasjonsfond',
  funds_fund_asset_class_type_kombinasjonsfond:
    'funds_fund_asset_class_type_kombinasjonsfond',
  funds_fund_asset_class_type_pengemarkedsfond:
    'funds_fund_asset_class_type_pengemarkedsfond',
  funds_fund_asset_class_type_annensparing:
    'funds_fund_asset_class_type_annensparing',
  funds_fund_asset_class_type_banksparing:
    'funds_fund_asset_class_type_banksparing',
  funds_fund_asset_class_type_forsikringssparing:
    'funds_fund_asset_class_type_forsikringssparing',
  funds_fund_asset_class_type_aksjer: 'funds_fund_asset_class_type_aksjer',
  funds_fund_asset_class_type_udefinert:
    'funds_fund_asset_class_type_udefinert',
  funds_overview_breadcrumb_funds: 'funds_overview_breadcrumb_funds',
  funds_fund_details: 'funds_fund_details',
  funds_overview_funds: 'funds_overview_funds',
  funds_overview_accounts: 'funds_overview_accounts',
  funds_overview_sorted_by_funds_title: 'funds_overview_sorted_by_funds_title',
  funds_overview_sort_by_funds_option: 'funds_overview_sort_by_funds_option',
  funds_overview_sort_by_accounts_option:
    'funds_overview_sort_by_accounts_option',
  funds_overview_sorted_by_accounts_title:
    'funds_overview_sorted_by_accounts_title',
  funds_savings_agreements_total_active:
    'funds_savings_agreements_total_active',
  funds_savings_agreements_create_new_button_text:
    'funds_savings_agreements_create_new_button_text',
  funds_browse_funds: 'funds_browse_funds',
  funds_fund_transactions_title: 'funds_fund_transactions_title',
  funds_savings_agreements_subtitle: 'funds_savings_agreements_subtitle',
  funds_savings_agreement_details_loading_text:
    'funds_savings_agreement_details_loading_text',
  funds_savings_agreement_details_error_text:
    'funds_savings_agreement_details_error_text',
  funds_savings_agreement_edit_button_text:
    'funds_savings_agreement_edit_button_text',
  funds_savings_agreement_delete_button_text:
    'funds_savings_agreement_delete_button_text',
  funds_savings_agreement_details_title:
    'funds_savings_agreement_details_title',
  funds_savings_agreement_details_from_account_label:
    'funds_savings_agreement_details_from_account_label',
  funds_savings_agreement_details_to_account_label:
    'funds_savings_agreement_details_to_account_label',
  funds_breadcrumb_funds_overview: 'funds_breadcrumb_funds_overview',
  funds_breadcrumb_savings_agreements: 'funds_breadcrumb_savings_agreements',
  funds_breadcrumb_fund_transactions: 'funds_breadcrumb_fund_transactions',
  funds_breadcrumb_fund_accounts: 'funds_breadcrumb_fund_accounts',
  funds_breadcrumb_browse: 'funds_breadcrumb_browse',
  funds_breadcrumb_savings: 'funds_breadcrumb_savings',
  funds_savings_agreement_edit_amount_is_required_error:
    'funds_savings_agreement_edit_amount_is_required_error',
  funds_amount_field_label: 'funds_amount_field_label',
  funds_savings_agreement_details_save_button_text:
    'funds_savings_agreement_details_save_button_text',
  funds_savings_agreement_details_cancel_button_text:
    'funds_savings_agreement_details_cancel_button_text',
  funds_savings_agreement_to_account_field_label:
    'funds_savings_agreement_to_account_field_label',
  funds_from_account_field_label: 'funds_from_account_field_label',
  funds_savings_agreement_to_account_field_form_status:
    'funds_savings_agreement_to_account_field_form_status',
  funds_savings_agreement_edit_frequency_is_required_error:
    'funds_savings_agreement_edit_frequency_is_required_error',
  funds_savings_agreement_frequency_input_label:
    'funds_savings_agreement_frequency_input_label',
  funds_form_account_field_label: 'funds_form_account_field_label',
  funds_savings_agreement_edit_account_is_required_error:
    'funds_savings_agreement_edit_account_is_required_error',
  funds_savings_agreement_stop_date_picker_label:
    'funds_savings_agreement_stop_date_picker_label',
  funds_savings_agreement_stop_date_picker_switch:
    'funds_savings_agreement_stop_date_picker_switch',
  funds_savings_agreement_stop_date_picker_error:
    'funds_savings_agreement_stop_date_picker_error',
  funds_savings_agreement_details_stop_date_label:
    'funds_savings_agreement_details_stop_date_label',
  funds_next_payment_date_picker_label: 'funds_next_payment_date_picker_label',
  funds_savings_agreement_edit_next_payment_date_is_required_error:
    'funds_savings_agreement_edit_next_payment_date_is_required_error',
  funds_savings_agreement_details_stop_date_missing_label:
    'funds_savings_agreement_details_stop_date_missing_label',
  funds_overview_return_since_label: 'funds_overview_return_since_label',
  funds_fund_pending_order_status_pending:
    'funds_fund_pending_order_status_pending',
  funds_fund_pending_order_status_in_progress:
    'funds_fund_pending_order_status_in_progress',
  funds_savings_agreements_title: 'funds_savings_agreements_title',
  funds_fund_order_widget_title: 'funds_fund_order_widget_title',
  funds_fund_order_widget_link_title: 'funds_fund_order_widget_link_title',
  funds_fund_order_widget_empty_state: 'funds_fund_order_widget_empty_state',
  funds_fund_order_type_redemption: 'funds_fund_order_type_redemption',
  funds_fund_order_type_purchase: 'funds_fund_order_type_purchase',
  funds_fund_order_type_switch: 'funds_fund_order_type_switch',
  funds_fund_order_type_tag_label: 'funds_fund_order_type_tag_label',
  funds_fund_order_status_tag_label: 'funds_fund_order_status_tag_label',
  funds_orders_skipped_fund_orders_error_message:
    'funds_orders_skipped_fund_orders_error_message',
  funds_fund_transactions_subtitle: 'funds_fund_transactions_subtitle',
  funds_order_details_amount_label: 'funds_order_details_amount_label',
  funds_order_details_order_id_label: 'funds_order_details_order_id_label',
  funds_order_details_order_info_title: 'funds_order_details_order_info_title',
  funds_order_details_order_info_text_purchase:
    'funds_order_details_order_info_text_purchase',
  funds_holdings_chart_button_three_years:
    'funds_holdings_chart_button_three_years',
  funds_holdings_chart_button_this_year:
    'funds_holdings_chart_button_this_year',
  funds_holdings_chart_button_one_week: 'funds_holdings_chart_button_one_week',
  funds_holdings_chart_button_one_month:
    'funds_holdings_chart_button_one_month',
  funds_holdings_chart_button_six_months:
    'funds_holdings_chart_button_six_months',
  funds_holdings_chart_button_one_year: 'funds_holdings_chart_button_one_year',
  funds_holdings_chart_button_five_years:
    'funds_holdings_chart_button_five_years',
  funds_fund_order_type_registered: 'funds_fund_order_type_registered',
  funds_fund_order_progress_buy_account_name:
    'funds_fund_order_progress_buy_account_name',
  funds_fund_order_progress_account_number:
    'funds_fund_order_progress_account_number',
  funds_fund_order_units: 'funds_fund_order_units',
  funds_fund_order_units_total_holding: 'funds_fund_order_units_total_holding',
  funds_fund_order_account_description_buy_switch:
    'funds_fund_order_account_description_buy_switch',
  funds_fund_order_account_description_sell:
    'funds_fund_order_account_description_sell',
  funds_fund_order_order_type_processing:
    'funds_fund_order_order_type_processing',
  funds_fund_order_expected_processing_time:
    'funds_fund_order_expected_processing_time',
  funds_fund_order_purchase_placed_on_account:
    'funds_fund_order_purchase_placed_on_account',
  funds_fund_order_sell_fund_sold_from_account:
    'funds_fund_order_sell_fund_sold_from_account',
  funds_fund_order_sell_placed_on_account:
    'funds_fund_order_sell_placed_on_account',
  funds_holdings_chart_return_info_ytd: 'funds_holdings_chart_return_info_ytd',
  funds_holdings_chart_return_info_one_week:
    'funds_holdings_chart_return_info_one_week',
  funds_holdings_chart_return_info_one_month:
    'funds_holdings_chart_return_info_one_month',
  funds_holdings_chart_return_info_six_months:
    'funds_holdings_chart_return_info_six_months',
  funds_holdings_chart_return_info_one_year:
    'funds_holdings_chart_return_info_one_year',
  funds_holdings_chart_return_info_three_years:
    'funds_holdings_chart_return_info_three_years',
  funds_holdings_chart_return_info_five_years:
    'funds_holdings_chart_return_info_five_years',
  funds_savings_agreement_edit_form_error:
    'funds_savings_agreement_edit_form_error',
  funds_transactions_filter_date_range_picker_label:
    'funds_transactions_filter_date_range_picker_label',
  funds_transactions_filter_search_input_label:
    'funds_transactions_filter_search_input_label',
  funds_transactions_filter_search_input_placeholder:
    'funds_transactions_filter_search_input_placeholder',
  funds_transactions_filter_download_button:
    'funds_transactions_filter_download_button',
  funds_transactions_filter_advanced_filter_button:
    'funds_transactions_filter_advanced_filter_button',
  funds_transactions_filter_active_filters_section_label:
    'funds_transactions_filter_active_filters_section_label',
  funds_transactions_filter_date_range_picker_last_six_months_button_label:
    'funds_transactions_filter_date_range_picker_last_six_months_button_label',
  funds_transactions_filter_date_range_picker_last_this_year_button_label:
    'funds_transactions_filter_date_range_picker_last_this_year_button_label',
  funds_transactions_filter_date_range_picker_last_last_year_button_label:
    'funds_transactions_filter_date_range_picker_last_last_year_button_label',
  funds_savings_agreement_edit_amount_min_amount_error:
    'funds_savings_agreement_edit_amount_min_amount_error',
  funds_savings_agreement_edit_amount_max_amount_error:
    'funds_savings_agreement_edit_amount_max_amount_error',
  funds_savings_agreement_edit_account_number_is_required_error:
    'funds_savings_agreement_edit_account_number_is_required_error',
  funds_savings_agreement_from_account_standing_order_info_message:
    'funds_savings_agreement_from_account_standing_order_info_message',
  funds_savings_agreement_details_edit_success:
    'funds_savings_agreement_details_edit_success',
  funds_savings_agreement_details_error_title:
    'funds_savings_agreement_details_error_title',
  funds_savings_agreement_details_save_error_subtitle:
    'funds_savings_agreement_details_save_error_subtitle',
  funds_savings_agreement_details_error_button:
    'funds_savings_agreement_details_error_button',
  funds_savings_agreement_details_delete_error_subtitle:
    'funds_savings_agreement_details_delete_error_subtitle',
  funds_savings_agreement_details_delete_success:
    'funds_savings_agreement_details_delete_success',
  funds_amount_range_picker_min_input_label:
    'funds_amount_range_picker_min_input_label',
  funds_amount_range_picker_max_input_label:
    'funds_amount_range_picker_max_input_label',
  funds_amount_range_picker_max_input_placeholder:
    'funds_amount_range_picker_max_input_placeholder',
  funds_amount_range_picker_min_input_placeholder:
    'funds_amount_range_picker_min_input_placeholder',
  funds_order_details_order_switched_from_fund_label:
    'funds_order_details_order_switched_from_fund_label',
  funds_checkboxlist_aria_label: 'funds_checkboxlist_aria_label',
  funds_savings_agreement_details_delete_heading:
    'funds_savings_agreement_details_delete_heading',
  funds_savings_agreement_details_delete_description:
    'funds_savings_agreement_details_delete_description',
  funds_order_details_order_info_text_redemption:
    'funds_order_details_order_info_text_redemption',
  funds_order_details_order_info_text_switch:
    'funds_order_details_order_info_text_switch',
  funds_fund_order_details_error_text: 'funds_fund_order_details_error_text',
  funds_orders_no_fund_orders: 'funds_orders_no_fund_orders',
  funds_fund_order_delete_button_text: 'funds_fund_order_delete_button_text',
  funds_fund_order_delete_heading: 'funds_fund_order_delete_heading',
  funds_fund_order_delete_description: 'funds_fund_order_delete_description',
  funds_fund_order_delete_confirm_button_text:
    'funds_fund_order_delete_confirm_button_text',
  funds_fund_order_delete_error_title: 'funds_fund_order_delete_error_title',
  funds_fund_order_delete_error_subtitle:
    'funds_fund_order_delete_error_subtitle',
  funds_fund_delete_error_try_again_button:
    'funds_fund_delete_error_try_again_button',
  funds_fund_order_not_cancellable_text:
    'funds_fund_order_not_cancellable_text',
  funds_fund_order_delete_success_notification:
    'funds_fund_order_delete_success_notification',
  funds_fund_accounts_no_holdings: 'funds_fund_accounts_no_holdings',
  funds_order_details_unit_label: 'funds_order_details_unit_label',
  funds_transactions_filter_drawer_account_option_title:
    'funds_transactions_filter_drawer_account_option_title',
  funds_transactions_filter_drawer_funds_option_title:
    'funds_transactions_filter_drawer_funds_option_title',
  funds_transactions_filter_drawer_amount_option_title:
    'funds_transactions_filter_drawer_amount_option_title',
  funds_transactions_filter_drawer_transaction_type_option_title:
    'funds_transactions_filter_drawer_transaction_type_option_title',
  funds_transactions_filter_drawer_show_button_label:
    'funds_transactions_filter_drawer_show_button_label',
  funds_transactions_filter_drawer_account_apply_button_label:
    'funds_transactions_filter_drawer_account_apply_button_label',
  funds_transactions_filter_drawer_funds_apply_button_label:
    'funds_transactions_filter_drawer_funds_apply_button_label',
  funds_transactions_filter_drawer_transaction_type_apply_button_label:
    'funds_transactions_filter_drawer_transaction_type_apply_button_label',
  funds_transactions_filter_drawer_amount_apply_button_label:
    'funds_transactions_filter_drawer_amount_apply_button_label',
  funds_fund_transaction_type_unknown: 'funds_fund_transaction_type_unknown',
  funds_fund_transaction_details_paid_from_account_label:
    'funds_fund_transaction_details_paid_from_account_label',
  funds_fund_transaction_details_placed_to_account_label:
    'funds_fund_transaction_details_placed_to_account_label',
  funds_fund_transaction_details_sold_from_account_label:
    'funds_fund_transaction_details_sold_from_account_label',
  funds_fund_transaction_details_switched_from_account_label:
    'funds_fund_transaction_details_switched_from_account_label',
  funds_fund_transaction_details_switched_to_account_label:
    'funds_fund_transaction_details_switched_to_account_label',
  funds_fund_transaction_details_moved_from_account_label:
    'funds_fund_transaction_details_moved_from_account_label',
  funds_fund_transaction_details_moved_to_account_label:
    'funds_fund_transaction_details_moved_to_account_label',
  funds_fund_transaction_details_error_text:
    'funds_fund_transaction_details_error_text',
  funds_fund_transaction_details_date_label:
    'funds_fund_transaction_details_date_label',
  funds_fund_transaction_details_quantity_label:
    'funds_fund_transaction_details_quantity_label',
  funds_fund_transaction_details_nav_label:
    'funds_fund_transaction_details_nav_label',
  funds_fund_transaction_details_costs_label:
    'funds_fund_transaction_details_costs_label',
  funds_fund_transaction_details_transaction_id_label:
    'funds_fund_transaction_details_transaction_id_label',
  funds_fund_transaction_details_return_section_header:
    'funds_fund_transaction_details_return_section_header',
  funds_fund_transaction_details_value_today_label:
    'funds_fund_transaction_details_value_today_label',
  funds_fund_transaction_details_unrealized_gain_label:
    'funds_fund_transaction_details_unrealized_gain_label',
  funds_fund_order_pending_transactions_title:
    'funds_fund_order_pending_transactions_title',
  funds_fund_order_pending_transactions_count_label:
    'funds_fund_order_pending_transactions_count_label',
  funds_fund_transactions_fetch_fund_transactions_error_title:
    'funds_fund_transactions_fetch_fund_transactions_error_title',
  funds_fund_transactions_fetch_fund_transactions_error_message:
    'funds_fund_transactions_fetch_fund_transactions_error_message',
  funds_fund_transactions_fetch_pending_orders_error_message:
    'funds_fund_transactions_fetch_pending_orders_error_message',
  funds_fund_transactions_fetch_pending_orders_error_title:
    'funds_fund_transactions_fetch_pending_orders_error_title',
  funds_savings_agreement_frequency_three_months:
    'funds_savings_agreement_frequency_three_months',
  funds_savings_agreement_frequency_four_months:
    'funds_savings_agreement_frequency_four_months',
};

Object.freeze(translationKeys);

export default translationKeys;
